import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SearchResults.css';

const SearchResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { searchResults, searchTerm } = location.state || { searchResults: [], searchTerm: '' };

    if (!searchResults || !searchResults.length) {
        return (
            <div className="search-results-container">
                <h2>No results found for "{searchTerm}"</h2>
                <button onClick={() => navigate(-1)}>Go Back</button>
            </div>
        );
    }

    return (
        <div className="search-results-container">
            <h2>Search Results for "{searchTerm}"</h2>
            <div className="results-grid">
                {searchResults.map((product) => (
                    <div key={product.id} className="product-card" onClick={() => navigate(`/product?_id=${product._id}&sellerName=${product.seller_id.name}&productName=${product.name}`)}>
                        <img src={product.product_image[0]} alt={product.name} className="product-image" />
                        <div className="product-info">
                            <h3>{product.name}</h3>
                            <p className="price">Ksh {product.discount_price}</p>
                            <p className="description">{product.short_description}</p>
                        </div>
                    </div>
                ))}
            </div>
            <button className="back-button" onClick={() => navigate(-1)}>Go Back</button>
        </div>
    );
};

export default SearchResults; 